module.exports = __webpack_public_path__ + "img/kim.0f5b3d08.svg";